// @flow
import * as React from 'react'
import type { Gathering } from 'types'
import { gatheringUrl } from 'urls'
import { toAbsoluteUrl } from 'util/url'
import FacebookIcon from 'icon/Social/FacebookIcon'
import TwitterIcon from 'icon/Social/TwitterIcon'
import Grid, { GridCell } from 'ui/Grid'
import Link from 'ui/Link'

import './ShareButtons.scss'

type Props = {
  gathering: Gathering,
}

export default class GatheringPageShareButtons extends React.Component<Props> {
  render = () => {
    return (
      <Grid gutters="skinny">
        <GridCell flex="none">
          <Link href={this.facebookUrl} target="_blank">
            <div className="GatheringPageShareButton">
              <FacebookIcon />
            </div>
          </Link>
        </GridCell>
        <GridCell flex="none">
          <Link href={this.twitterUrl} target="_blank">
            <div className="GatheringPageShareButton">
              <TwitterIcon />
            </div>
          </Link>
        </GridCell>
      </Grid>
    )
  }

  get url(): string {
    return toAbsoluteUrl(gatheringUrl(this.props.gathering))
  }

  get facebookUrl(): string {
    const u = encodeURIComponent(this.url)
    return `https://www.facebook.com/sharer/sharer.php?u=${u}`
  }

  get twitterUrl(): string {
    const text = encodeURIComponent(`Join me at ${this.props.gathering.name}, ${this.url}`)
    return `https://twitter.com/intent/tweet?text=${text}`
  }
}
